module.exports = __webpack_public_path__ + "img/cb-step-list.671339d4.svg";